import { Theme, css } from '@emotion/react';

import { ReactNode } from 'react';

import { Radius } from 'chatie-design-system';

const containerCSS = (theme: Theme) => css`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 216px;
  flex-direction: column;
  border-radius: ${Radius.small}px;
  overflow: hidden;
  background-color: ${theme.var.white};
  box-shadow: 3px -2px 20px 10px #0000000d;
`;

const Card = ({ children }: { children: ReactNode }) => {
  return <div css={containerCSS}>{children}</div>;
};

export default Card;
